import { useState } from "react";
import { startVerification } from "./api";
import logo from "../../assets/maksu-logo.jpg";
import "./idv.css";

const CHECKLIST = [
  "Takes less than 2 minutes",
  "Have your government-issued ID ready",
  "Make sure your camera is working",
];

export default function StartPage() {
  const [form, setForm] = useState({ firstName: "", lastName: "", email: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const update = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const veriffUrl = await startVerification(form);
      window.location.href = veriffUrl; // hand over to Veriff's hosted screens
    } catch (err) {
      setError(
        err.message === "Failed to fetch"
          ? "Verification service is unavailable right now. Please try again later or contact support."
          : err.message
      );
      setLoading(false);
    }
  }

  return (
    <div className="idv-page">
      <div className="idv-split">
        <div className="idv-intro">
          <div className="idv-brand">
            <img src={logo} alt="MAKSU" className="idv-logo" />
            <span className="idv-byline">(UTek)</span>
          </div>
          <h1>Identity verification</h1>
          <p className="idv-text">
            Enter your details to begin. You'll be asked to photograph your ID and take a selfie.
          </p>
          <ul className="idv-checklist">
            {CHECKLIST.map((item) => (
              <li key={item}>
                <span className="idv-tick" aria-hidden="true">✓</span>
                {item}
              </li>
            ))}
          </ul>
        </div>

        <div>
          <form className="idv-form-card" onSubmit={handleSubmit}>
            <p className="idv-form-title">Your details</p>
            <label>
              Email address
              <input name="email" type="email" placeholder="you@example.com"
                value={form.email} onChange={update} required />
            </label>
            <div className="idv-row">
              <label>
                First name
                <input name="firstName" placeholder="Jane" value={form.firstName} onChange={update} required />
              </label>
              <label>
                Last name
                <input name="lastName" placeholder="Smith" value={form.lastName} onChange={update} required />
              </label>
            </div>

            {error && <p className="idv-error">{error}</p>}

            <button type="submit" disabled={loading}>
              {loading ? "Starting…" : "Start verification"}
            </button>
          </form>

          <p className="idv-note">
            <strong>Your data is safe.</strong> Personal information is encrypted in transit and
            used only for identity verification.
          </p>
        </div>
      </div>
    </div>
  );
}